<div class="container">
  <ng-wizard [config]="config" (stepChanged)="stepChanged($event)">
    <ng-wizard-step
      [title]="'Step 1'"
      [description]="'Add Institution'"
      class="form-background">

      <span>
        <app-add-institution
          (apiEvent)="apiEventHandle($event)"
          (btnClicked)="showNextStep()"
        ></app-add-institution>
      </span>
    </ng-wizard-step>

    <ng-wizard-step [title]="'Step 2'" [description]="'Assign Exchanges'">
      <span>
        <app-add-exchange (btnClicked)="showNextStep()"></app-add-exchange>
      </span>
    </ng-wizard-step>

    <ng-wizard-step
      [title]="'Step 3'"
      [description]="'Bank'"
      [canExit]="isValidFunctionReturnsBoolean.bind(this)"
    >
      <span>
        <app-add-bank></app-add-bank>
      </span>
    </ng-wizard-step>

    <ng-wizard-step
      [title]="'Step 4'"
      [description]="'Customer Default Profile'"
    >
      <span>
        <app-customer-creation
          (btnClicked)="showNextStep()"
        ></app-customer-creation>
      </span>
    </ng-wizard-step>

    <ng-wizard-step [title]="'Step 5'" [description]="'Master Account'">
      <span>
        <app-create-master-account></app-create-master-account>
      </span>
    </ng-wizard-step>
    <ng-wizard-step [title]="'Step 6'" [description]="'Trading Limits'">
      <span>
        <app-trading-limits-institution></app-trading-limits-institution>
      </span>
    </ng-wizard-step>
    <ng-wizard-step [title]="'Step 7'" [description]="'Summary'">
      <span>
        <app-summary-create-institution></app-summary-create-institution>
      </span>
    </ng-wizard-step>

    <div
      class="btn-toolbar ng-wizard-toolbar ng-wizard-toolbar-bottom justify-content-end ng-star-inserted"
    >
      <div class="btn-group mr-2 ng-wizard-btn-group">
        <button
          *ngIf="selectedStep != 0 && selectedStep != 6"
          (click)="onClickPrevious()"
          ng-reflect-ng-class="btn btn-secondary ng-wizard-bt"
          class="ng-star-inserted btn btn-secondary ng-wizard-btn-prev"
        >
          Previous
        </button>
        <button
          *ngIf="selectedStep != 5 && selectedStep != 6"
          (click)="onClickNext()"
          ng-reflect-ng-class="btn btn-secondary ng-wizard-bt"
          class="btn btn-secondary ng-wizard-btn-next ng-star-inserted"
        >
          Next
        </button>
        <button
          *ngIf="selectedStep == 5"
          ng-reflect-ng-class="btn btn-secondary ng-wizard-bt"
          class="btn btn-secondary ng-wizard-btn-next ng-star-inserted"
          (click)="done()"
        >
          Done
        </button>
        <button
          *ngIf="selectedStep == 6"
          (click)="onClickNext()"
          ng-reflect-ng-class="btn btn-secondary ng-wizard-bt"
          class="btn btn-secondary ng-wizard-btn-next ng-star-inserted"
          (click)="finish()"
        >
          Finish
        </button>
      </div>
    </div>
  </ng-wizard>
</div>
